export default [
    {
        path: "/",
        name: "home",
        component: () => import('./pages/index.vue')
    },
    {
        path: '/my-profile',
        component: () => import("./pages/my-profile.vue")
    },
    {
        path: '/forget-password',
        component: () => import("./pages/forget-password.vue")
    },
    {
        name: "verify-phone",
        path: '/verify-phone',
        props: true,
        component: () => import("./pages/verify-phone.vue")
    },
    {
        name: "reset-password",
        props: true,
        path: '/reset-password',
        component: () => import("./pages/reset-password.vue")
    },
    {
        name: "success",
        path: '/success',
        props: true,
        component: () => import("./pages/success.vue")
    },
    {
        path: '/registration',
        component: () => import("./pages/registration.vue")
    },
    {
        path: '/transfer-existing-account',
        component: () => import("./pages/transfer-existing-account.vue")
    },
    {
        name: "two-step-authenication-one",
        path: '/two-step-authenication-one',
        component: () => import("./pages/two-step-authenication-one.vue")
    },
    {
        name: "two-step-authenication-two",
        path: '/two-step-authenication-two',
        props: true,
        component: () => import("./pages/two-step-authenication-two.vue")
    },
    {
        name: "update-account",
        path: '/update-account',
        props: true,
        component: () => import("./pages/update-account.vue")
    }, {
        name: "transfer-account",
        path: '/transfer-account',
        props: true,
        component: () => import("./pages/transfer-account.vue")
    },
]